import React from "react";
import dataSuccess from "../../data/dataSuccess";
import MaPrimeRenovBlock from "./MaPrimeRenovBlock";
import ErrorHandler from "../ErrorHandler";
import NavSuccess from "./NavSuccess";
import SuccessTemplateSidebar from "./SuccessTemplateSidebar";
import InfoHoverBlock from "./InfoHoverBlock";
import FileUploaderAuto from "./FileUploaderAuto";
import PrimeBlock from "./PrimeBlock";
class SuccessAudit extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const bgMobile = `url(${dataSuccess[this.props.success].imgMobile})`;
    const H1audit = this.props.Q48 ? this.props.Q48 : "Audit énergétique";
    if (this.props.result.success == "false") {
      return (
        <ErrorHandler
          message={this.props.result.message}
          reset={this.props.reset}
        ></ErrorHandler>
      );
    } else {
      const APIresult = this.props.result.data;
      const MaPrimeRenov = APIresult["Montant MPR unitaire (€)"];
      const PrimeHellio = APIresult["Montant prime CEE unitaire (€)"];
      const price1 = this.props.answers.Q43
        ? new Intl.NumberFormat("fr-FR", { currency: "EUR" }).format(
            this.props.answers.Q43,
          )
        : APIresult["Coût travaux unitaire (€)"];
      const price2 = MaPrimeRenov || PrimeHellio;
      const price3 = APIresult["Reste à charge unitaire (€)"];
      const pricePromo = APIresult["Coût travaux promotion (€)"];
      return (
        <div className="flex-container">
          <SuccessTemplateSidebar
            success={this.props.success}
            lastStep={this.props.lastStep}
            H1audit={H1audit}
            codePromo={this.props.codePromo}
            handleCodePromo={this.props.handleCodePromo}
            validCodePromo={this.props.validCodePromo}
            resultCodePromo={this.props.resultCodePromo}
          >
            <div className="success-item">
              <h3>Type de logement</h3>
              <h2>{this.props.Q2}</h2>
            </div>
            {this.props.surface && (
              <div className="success-item">
                <h3>Surface</h3>
                <h2>
                  {" "}
                  {this.props.surface} m
                  <sup style={{ fontSize: "0.7em" }}>2</sup>{" "}
                </h2>
              </div>
            )}

            {this.props.result.data["Couleur MPR"] && (
              <MaPrimeRenovBlock
                color={this.props.result.data["Couleur MPR"]}
              ></MaPrimeRenovBlock>
            )}

            <div className="success-item">
              <h3>Système de chauffage</h3>
              <h2>{this.props.Q22}</h2>
            </div>
          </SuccessTemplateSidebar>
          <div className="success-right-container">
            {/* {this.props.success !== 'AuditEnergetique' && (
              <h3
                className="mt-10 is-hidden-mobile"
                style={{ lineHeight: '1.1em' }}
              >
                {dataSuccess[this.props.success]['h2']}
              </h3>
            )} */}

            <div className="success-item-right">
              <h5>
                {this.props.success == "AuditEnergetique" ||
                this.props.success == "RenovationGlobale"
                  ? "Coût de l’audit énergétique"
                  : "Estimation du coût de mes travaux"}
              </h5>
              <div>
                {!pricePromo && (
                  <h5 className="h5-price text-main">
                    {" "}
                    {price1} €{" "}
                    <span
                      className={
                        this.props.Q48 === "Audit règlementaire"
                          ? ""
                          : "is-hidden"
                      }
                      style={{ fontSize: "14px" }}
                    >
                      TTC
                    </span>
                  </h5>
                )}
                {pricePromo && (
                  <div>
                    <h2>
                      <del>
                        {price1} € {""}
                      </del>
                    </h2>
                    <h1 style={{ lineHeight: "1em" }} className="text-sub2">
                      {pricePromo} €{" "}
                      {dataSuccess[this.props.success].showM2 && (
                        <span className="second">/ m² </span>
                      )}
                    </h1>
                  </div>
                )}
              </div>
            </div>
            {pricePromo && (
              <p className="text-sub2 is-light text-s mt-5">
                <i>
                  offre limitée jusqu'au <strong>31 Mars 2023</strong>
                </i>
              </p>
            )}
            <PrimeBlock
              APIresult={APIresult}
              success={this.props.success}
              resultCodePromo={this.props.resultCodePromo}
            ></PrimeBlock>
            <div>
              <div
                className={
                  (price2 == null &&
                    !this.props.resultCodePromo.data.reste_a_charge) ||
                  this.props.resultCodePromo.data.reste_a_charge === price3
                    ? "is-hidden"
                    : ""
                }
              >
                <div className="success-item-right last">
                  <h5>Reste à payer</h5>
                  <div>
                    {this.props.resultCodePromo.data.reste_a_charge && (
                      <h5 className="h5-price">
                        {this.props.resultCodePromo.data.reste_a_charge} €
                      </h5>
                    )}

                    {!this.props.resultCodePromo.data.reste_a_charge && (
                      <h5 className="h5-price"> {price3} € </h5>
                    )}
                  </div>
                </div>
              </div>

              {this.props.showFile && (
                <FileUploaderAuto
                  patchName="fileImposition"
                  description="Déposez votre avis imposition pour valider le montant de votre prime"
                  handleFile={this.props.handleFile}
                  result={this.props.result}
                  firstname={this.props.contact.firstname}
                  lastname={this.props.contact.lastname}
                ></FileUploaderAuto>
              )}
            </div>
            <NavSuccess
              callBtn={this.props.callBtn}
              lastStep={this.props.lastStep}
              date={this.props.date}
              creneau={this.props.creneau}
              handleDate={this.props.handleDate}
              handleCreneau={this.props.handleCreneau}
              price2={price2}
            ></NavSuccess>

            <p className="paragraph">
              {dataSuccess[this.props.success].paragraph} <br />
              <span className="is-bold">
                {dataSuccess[this.props.success].paragraphBold}
              </span>
            </p>
          </div>
          <div
            style={{
              backgroundImage: bgMobile,
            }}
            className="success-header-img only-show-mobile"
          >
            <h1>{dataSuccess[this.props.success].h1}</h1>
          </div>
        </div>
      );
    }
  }
}

export default SuccessAudit;
